import React from "react";

/**
 * @component ImageIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ImageIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ImageIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ImageIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4a2 2 0 011.994 1.85L22 6v12a2 2 0 01-1.85 1.994L20 20H4a2 2 0 01-1.995-1.85L2 18V6a2 2 0 011.85-1.995L4 4h16zm0 2H4v12h16V6zm-5.5 4l4.5 6H5l3.5-4.5 2.5 3 3.5-4.5zm-8-3a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
      />
    </svg>
  )
);
ImageIcon.displayName = "ImageIcon";
export default ImageIcon;
